import api from '../api';
import { getFromSessionStorage } from '../../constants/functions';
import { Regra } from '../../pages/BidOffer';

export const getOffers = async (gruposCota: any[]) => {
  const url = `/oferta`;
  try {
    const res = (await api.post(
      url,
      {
        selectedOffers: gruposCota,
      },
      {
        headers: { token: getFromSessionStorage('token') },
      }
    )) as OffersRes;

    const defaultRule = res.regras.find((regra) => regra.forma === '99');

    if (!defaultRule) {
      const codigoRegra = res.regras && res.regras.length > 0 ? res.regras[0].codigo : '004';
      res.regras.unshift({
        codigo: codigoRegra,
        prioridade: '999',
        forma: '99',
        descricao: 'Selecione o tipo de lance',
        minimo: '000',
        maximo: '000',
        quantidade: '0000',
        limite: '0000',
        maxLanceEmbutido: '000',
        tipoCalcLanceEmbutido: '2',
        notMapped: '',
      });
    }

    return { res: res as OffersRes, success: true };
  } catch (e) {
    return { res: e as any, success: false };
  }
};
export const calculateOffers = async (offers: any[]) => {
  const url = `/oferta/calcular`;
  try {
    const res = (await api.post(
      url,
      {
        selectedOffers: offers,
      },
      {
        headers: { token: getFromSessionStorage('token') },
      }
    )) as any;
    return res;
  } catch (e) {
    // console.log(e);

    return (e as any).response.data;
  }
};
export const saveOffers = async (offers: any[]) => {
  const url = `/oferta/salvar`;
  try {
    const res = (await api.post(
      url,
      {
        selectedOffers: offers,
      },
      {
        headers: { token: getFromSessionStorage('token') },
      }
    )) as any;
    return res;
  } catch (e) {
    return null;
  }
};

export interface Bid {
  lanceEmbutidoLiberarConso: string;
  lancePercentualLimitadoMinimo: string;
  lanceValorMaximoGrupo: string;
  '25': string;
  lanceDataAssembleia: string;
  lanceMaxEmbutido: string;
  '26': string;
  '27': string;
  lanceGrupo: string;
  lanceValorLimitadoMaximo: string;
  '28': string;
  lanceFormaContemplacaoQta: string;
  '29': string;
  lanceCota: string;
  lanceValorMediaGrupo: string;
  lanceQtdeMaximoGrupo: string;
  lancePrioridadeRegraQta: string;
  '30': string;
  lanceEmbutidoQta: string;
  '31': string;
  '32': string;
  lanceQtdeMinimoGrupo: string;
  '33': string;
  '34': string;
  lanceValorLimitadoMinimo: string;
  lanceCodRegraApuracao: string;
  lanceTipoLance: string;
  lanceLimitado: string;
  lanceDescricaoRegraApuracao: string;
  lanceQtdeMediaGrupo: string;
  lanceOferta: string;
  regraEmbutido: string;
  lanceOfertaEmValor: string;
  lancePercentualLimitadoMaximo: string;
  lanceValorMinimoGrupo: string;
  lanceCodRegraApuracaoQta: string;
  lanceEmbutidoAplicar: string;
  lanceEmbutidoAlterarConso: string;
}

export interface OffersRes {
  lances: Bid[];
  regras: Regra[];
}
